// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZLhB","title":"styles_title__3UodZ"};